export const initialDataState = {};

export const accountTypes = [
  {
    label: "Internal",
    value: "Internal",
  },
  {
    label: "External",
    value: "External",
  },
];

export const accountStatus = [
  {
    label: "On Leave",
    value: "On Leave",
  },
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Block",
    value: "Block",
  },
];

export const assignmentList = [
  {
    label: "CIT",
    value: "CIT",
  },
  {
    label: "ATM",
    value: "ATM",
  },
  {
    label: "HUB",
    value: "HUB",
  },
  {
    label: "FLM",
    value: "FLM",
  },
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "NA",
    value: "NA",
  },
];

export const staffTypes = [
  {
    value: "Field Staff",
    label: "Field Staff",
  },
  {
    value: "Office Based Staff",
    label: "Office Based Staff",
  },
];

export const formDefaultValues = {
  employeeId: "",
  userName: "",
  password: "",
  firstName: "",
  lastName: "",
  nationality: "",
  email: "",
  personalEmail: "",
  accountType: null,
  mobileNo: "",
  personalMobileNo: "",
  status: null,
  designation: "",
  assignment: null,
  dateOfBirth: null,
  dateOfJoining: null,
  nationalId: "",
  nationalIdExpiry: null,
  passportNumber: "",
  passportExpiry: null,
  drivingLicenseNo: "",
  drivingExpiry: null,
  cashCenterId: null,
  officeId: null,
  clientId: "",
  roles: [],
  cenconId: "",
  staffType: "",
  businessUnit: "",
  state: "",
  city: "",
  emirate: "",
  managerId: "",
};

export const formValidationRules = {};

export const editUserFormValued = (payload, rolesList) => {
  let _roles = [];

  if (payload.roles && payload.roles.length) {
    _roles = rolesList
      .filter((elm) => payload.roles.findIndex((r) => r === elm.name) !== -1)
      .map((elm) => ({
        name: elm.name,
      }));
  }

  const values = {
    ...payload,
    password: "",
    isAzureAd: payload.isAzureAd ? "Yes" : "No",
    dateOfBirth: payload.dateOfBirth ? new Date(payload.dateOfBirth) : null,
    dateOfJoining: payload.dateOfJoining
      ? new Date(payload.dateOfJoining)
      : null,
    nationalId: payload.nationalId,
    nationalIdExpiry: payload.nationalIdExpiry
      ? new Date(payload.nationalIdExpiry)
      : null,
    passportNumber: payload.passportNo,
    passportExpiry: payload.passportExpiry
      ? new Date(payload.passportExpiry)
      : null,
    drivingExpiry: payload.drivingLicenseExpiry
      ? new Date(payload.drivingLicenseExpiry)
      : null,
    roles: _roles,
  };

  return values;
};
